import { Box, BoxProps } from "@material-ui/core";
import React from "react";
import FaqEmbeddableSection from "../../../../content-modules/faq-embeddable-section";

type Props = {
  title: string;
  questionsAnswers: {
    question: string;
    answerNode: {
      childMarkdownRemark: {
        html: string;
      };
    };
  }[];
} & BoxProps;

export default function ActivationFAQ({
  title,
  questionsAnswers,
  ...boxProps
}: Props) {
  return (
    <Box {...boxProps}>
      <FaqEmbeddableSection
        title={title}
        questionsAnswers={questionsAnswers}
        defaultCollapsed
      />
    </Box>
  );
}
